import { useContext } from "react";
import { FaRegComment } from "react-icons/fa";
import { usePost, usePostValue } from "../../..";
import customEvents from "../../../../../common/customEvents";
import { ProfileContext } from "../../../../../context/profileContext";
import UActionButton from "../../../UI/UActionButton";

type Props = {};

const CommentsButton = (props: Props) => {
  const profile = useContext(ProfileContext);

  const { setOne: setOnePostContext } = usePost();

  const commentsLen = usePostValue((s) => s.comments.length);

  const handleOpenComments = () => {
    if (commentsLen == 0 && !profile) {
      window.dispatchEvent(new Event(customEvents.openLoginField));
    }
    setOnePostContext("isCommentsHidden", (v) => !v);
  };

  return (
    <UActionButton onClick={handleOpenComments}>
      <FaRegComment />
      <span>{commentsLen == 0 ? "Write first comment!" : commentsLen}</span>
    </UActionButton>
  );
};

export default CommentsButton;
